// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vhSE7_6SMjtQPN {
  padding: 8px 4px 4px;
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
}
.vhSE7_6SMjtQPN hr {
  margin: 16px 0;
}
.vhSE7_6SMjtQPN .LB6jfJgYUnbso7 {
  margin-left: 4px;
  color: var(--ds-text-subtle, #44546f);
}
.vhSE7_6SMjtQPN ._BxtCAVy18cXxL {
  margin-bottom: 3px;
}
.vhSE7_6SMjtQPN .TbHBOkIIfy3max {
  color: var(--ds-text-subtle, #44546f);
}
.vhSE7_6SMjtQPN .TbHBOkIIfy3max:hover {
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popoverContent": `vhSE7_6SMjtQPN`,
	"visibilityText": `LB6jfJgYUnbso7`,
	"visibilityIcon": `_BxtCAVy18cXxL`,
	"learnMoreLink": `TbHBOkIIfy3max`
};
export default ___CSS_LOADER_EXPORT___;
